import { FieldProps } from 'formik';
import * as React from 'react';
import ErrorTextField from './ErrorTextField';

interface FormFieldProps extends FieldProps {
	required?: boolean;
}

const LinkedInUrl: React.StatelessComponent<FormFieldProps> = function (props) {
	const {
		form: { errors, touched },
		field,
		required,
	} = props;
	const name = field.name;

	return <ErrorTextField
		errorMessage={touched[name] ? errors[name] as string : undefined}
		label='LinkedIn URL'
		required={required}
		{...field}
	/>;
};

export default LinkedInUrl;
